import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ROLES } from '../constants/roles.constants';

@Injectable({
  providedIn: 'root'
})
export class AnimateurGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const user = this.authService.getCurrentUser();
    
    if (!user) {
      this.router.navigate(['/auth/login']);
      return false;
    }

    // Vérifier si l'utilisateur a le rôle animateur
    const isAnimateur = user.role?.nom === ROLES.ANIMATEUR;
    
    if (isAnimateur) {
      return true;
    }
    
    // Rediriger vers le dashboard approprié selon le rôle
    const roleNom = user.role?.nom;
    
    switch (roleNom) {
      case ROLES.ADMIN:
      case ROLES.SUPERADMIN:
        this.router.navigate(['/dashboard']);
        break;
      case ROLES.FAMILLE:
        this.router.navigate(['/dashboard-famille']);
        break;
      case ROLES.EHPAD:
        this.router.navigate(['/dashboard-gestionnaire']);
        break;
      default:
        this.router.navigate(['/auth/login']);
        break;
    }
    
    return false;
  }
}
